// extracted by mini-css-extract-plugin
export var eyebrow = "_de-3";
export var heroImage = "_de-4";
export var main = "_de-2";
export var modal = "_de-0";
export var shell = "_de-1";